export type RolesSearch = {
  accountId?: string;
};

const isUuid = (v: unknown): v is string =>
  typeof v === 'string' &&
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(v);

export const validateRolesSearch = (
  input: Record<string, unknown>
): RolesSearch => ({
  accountId: isUuid(input.accountId) ? input.accountId : undefined,
});
